import { c as _c } from "react/compiler-runtime";
import CreateModuleModal, { CreateModuleModalInterface } from 'modules/courses/courses/curriculum/components/create-module-modal';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { EmptyListIcon } from '@systemeio/ui/icons';
interface CourseCurriculumEmptyListInterface extends Omit<CreateModuleModalInterface, 'withIcon'> {}
const CourseCurriculumEmptyList = t0 => {
  const $ = _c(19);
  const {
    onModuleCreate,
    courseId,
    disabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EmptyListIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.list.empty_title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-text-primary text-base">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("dashboard.list.empty_list");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-text-primary text-base">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex flex-col items-center">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== courseId || $[13] !== disabled || $[14] !== onModuleCreate) {
    t7 = <CreateModuleModal onModuleCreate={onModuleCreate} courseId={courseId} disabled={disabled} withIcon={false} />;
    $[12] = courseId;
    $[13] = disabled;
    $[14] = onModuleCreate;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="bg-background-secondary mt-5 flex w-full flex-col items-center justify-center gap-3 rounded-lg py-20">{t1}{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default CourseCurriculumEmptyList;